import type { Session } from "@supabase/supabase-js";
import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { isFull } from "../lib/auth";
import styles from "./AppShell.module.css";

const NAV = [
  { to: "/", label: "Board", end: true, fullOnly: false },
  { to: "/contratos/novo", label: "Novo contrato", end: false, fullOnly: true },
  { to: "/handoffs", label: "Handoffs", end: false, fullOnly: false },
];

export function AppShell({ session, children }: { session: Session; children: ReactNode }) {
  const email = session.user.email ?? "";
  const full = isFull(session);
  const nav = NAV.filter((n) => full || !n.fullOnly);

  return (
    <div className={styles.shell}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <div className={styles.brand}>
            <img src="/logo-reach.png" alt="Reach Up" className={styles.mark} width={30} height={30} />
            <span className={styles.wordmark}>Sucesso do Cliente</span>
          </div>
          <nav className={styles.nav}>
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) => `${styles.navLink} ${isActive ? styles.navActive : ""}`}
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className={styles.userBox}>
            <span className={styles.email} title={email}>{email}</span>
            <button
              className={styles.signout}
              onClick={() => supabase.auth.signOut()}
            >
              Sair
            </button>
          </div>
        </div>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
